var React = require('react');

function ThumbUpInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"thumb_up_alt_24px"},React.createElement("path",{"id":"icon/social/thumb_up_alt_24px","fillRule":"evenodd","clipRule":"evenodd","d":"M43.7499 18.75H30.6041L32.5833 9.22917L32.6458 8.56251C32.6458 7.70834 32.2916 6.91667 31.7291 6.35417L29.5208 4.16667L15.8124 17.8958C15.0416 18.6458 14.5833 19.6875 14.5833 20.8333V41.6667C14.5833 43.9583 16.4583 45.8333 18.7499 45.8333H37.4999C39.2291 45.8333 40.7082 44.7917 41.3332 43.2917L47.6249 28.6042C47.8124 28.125 47.9166 27.625 47.9166 27.0833V22.9167C47.9166 20.625 46.0416 18.75 43.7499 18.75ZM43.7499 27.0833L37.4999 41.6667H18.7499V20.8333L27.7916 11.7917L25.4791 22.9167H43.7499V27.0833ZM10.4166 20.8333H2.08325V45.8333H10.4166V20.8333Z","fill":"#FF5C5C"})));
}

ThumbUpInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = ThumbUpInline;

ThumbUpInline.default = ThumbUpInline;
